import { http } from '@/libs'
import type { Verifier } from '../types'
import { message } from 'ant-design-vue'

export default {
  async send({ passageKey, securityCode, condition }) {
    await http.call({
      url: '/api/security/send_code',
      method: 'POST',
      data: {
        passage_key: passageKey,
        security_code: securityCode,
        verification_type: condition.type,
      },
      useAuth: false,
    })
  },

  async verify({ passageKey, securityCode, proof, condition }) {
    const { check_result, passage_key_result } = await http.call<{
      check_result: boolean
      passage_key_result: boolean
    }>({
      url: '/api/security/submit',
      method: 'POST',
      data: {
        passage_key: passageKey,
        security_code: securityCode,
        verification_type: condition.type,
        verification_code: proof?.code, // proof 由 UI 传入
      },
      useAuth: false,
    })
    return { ok: check_result === true }
  },
} satisfies Verifier
